"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var PriceClassificationFlag_1 = require("../model/PriceClassificationFlag");

var PriceClassificationsBinding_1 = require("../model/PriceClassificationsBinding");

var PriceClassificationsBindingConverter_1 = require("./PriceClassificationsBindingConverter");
/**
 * Implementation of {@link PriceClassificationsBindingConverter}.
 *
 * @author RV
 */


var PriceClassificationsBindingConverterImpl =
/*#__PURE__*/
function (_PriceClassifications) {
  _inherits(PriceClassificationsBindingConverterImpl, _PriceClassifications);

  function PriceClassificationsBindingConverterImpl() {
    _classCallCheck(this, PriceClassificationsBindingConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(PriceClassificationsBindingConverterImpl).apply(this, arguments));
  }

  _createClass(PriceClassificationsBindingConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new PriceClassificationsBinding_1.PriceClassificationsBinding(conversions.asEnum(source.autoFlag, PriceClassificationsBinding_1.PriceClassification), source.userFlag ? conversions.asEnum(source.userFlag, PriceClassificationsBinding_1.PriceClassification) : null, conversions.asEnum(source.externalFlag, PriceClassificationsBinding_1.PriceClassification), PriceClassificationsBinding_1.PriceClassificationsBinding.schema.priceZoneId.valueOf(conversions.toClassReferenceId(source.priceZoneId)), conversions.asFlagSet(source.flags, PriceClassificationFlag_1.PriceClassificationFlag));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        autoFlag: source.autoFlag,
        userFlag: source.userFlag,
        externalFlag: source.externalFlag,
        priceZoneId: conversions.toDocumentReferenceId(source.priceZoneId),
        flags: source.flags ? source.flags.serialize() : null
      });
      return result;
    }
  }]);

  return PriceClassificationsBindingConverterImpl;
}(PriceClassificationsBindingConverter_1.PriceClassificationsBindingConverter);

exports.PriceClassificationsBindingConverterImpl = PriceClassificationsBindingConverterImpl;